import http, { HttpSuccessOrErrorType } from '../http';
import { ResultSetHeader, Rule } from '../../models';
import { R10Rule, R7Rule, R1Rule } from '../../models/abstract/rule.constant';
export default {
    /**
     * 创建单个 rule 资源
     * @param params 参数
     */
    async post_restaurant_id_rule(params: Rule): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { _id, ...rest } = params;
        return await http.post(`/restaurant/${_id}/rule`, {
            ...rest
        })
    },

    /**
     * 创建批量 rule 资源
     * @param params 参数
     */
    async post_restaurant_id_rules(params: { id: string, ruleSetInfo: Array<Rule> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { id, ruleSetInfo } = params;
        return await http.post(`/restaurant/${id}/rules`, ruleSetInfo)
    },

    /**
     * 查询指定餐厅的所有 rule 资源
     * @param params 参数
     */
    async get_restaurant_id_rule(id: string,): Promise<HttpSuccessOrErrorType<Rule[]>> {
        return await http.get(`/restaurant/${id}/rule`, {})
    },

    /**
     * 查询指定餐厅的所有 rule 资源
     * @param params 参数
     */
    async get_restaurant_rid_rule_id(params: { rid: string, id: string }): Promise<HttpSuccessOrErrorType<Rule | null>> {
        const { rid, id } = params;
        return await http.get(`/restaurant/${rid}/rule/${id}`, {
        })
    },

    /**
     * 查询指定餐厅的所有 rule 资源
     * @param params 参数
     */
    async get_restaurant_rid_rules_condition(params: { string_id: string, code: string, _id?: string, dish_id?: string }): Promise<HttpSuccessOrErrorType<{
        dbResults: Rule[],
        totalCount: { count: number }
    }>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/rules/condition`, {
            params: {
                ...rest
            },
        })
    },

    /**
     * 查询指定餐厅的所有 rule 资源
     * @param params 参数
     */
    async get_restaurant_rid_rule_menu(params: { rid: string, code: string } & R7Rule & R10Rule & R1Rule): Promise<HttpSuccessOrErrorType<Rule[]>> {
        const { rid, ...rest } = params;
        return await http.get(`/restaurant/${rid}/rule/menu`, {
            params: {
                ...rest,
            },
        })
    },

    /**
     * 修改指定餐厅的单个rule资源。
     * @param params 参数
     */
    async patch_restaurant_rid_rule_id(params: Rule & { rid: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { rid, _id, ...rest } = params;
        return await http.patch(`/restaurant/${rid}/rule/${_id}`, {
            ...rest
        })
    },

    /**
     * 删除指定餐厅的单个rule资源。
     * @param params 参数
     */
    async delete_restaurant_rid_rule_id(params: { rid: string, id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { rid, id } = params;
        return await http.delete(`/restaurant/${rid}/rule/${id}`, {
        })
    },



}
